
<div class="d-flex align-items-baseline mr-3">
  <div class="menu-wrapper btn btn-secondary btn-link">    
    <span id="dynamic-list-csv-menu">
      <i (click)="itemClick()" class="now-ui-icons arrows-1_cloud-download-93"></i>
    </span>
  </div>
</div>

